import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { IPermission } from '../../utils/interfaces/profile';
import { IResponse } from '../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly URI_API = environment.apiConfig.uri;

  constructor(private readonly httpClient: HttpClient) {}

  getAllPermission(): Observable<IResponse<IPermission[]>> {
    return this.httpClient.get<IResponse<IPermission[]>>(
      `${this.URI_API}Permission/all`
    );
  }

  createProfilePermission(data: {
    idRole: string;
    permissionList: string[];
  }): Observable<IResponse<string>> {
    return this.httpClient.post<IResponse<string>>(
      `${this.URI_API}RolePermission/create`,
      data
    );
  }

  deleteProfilePermission(
    permissionList: string[]
  ): Observable<IResponse<boolean>> {
    return this.httpClient.post<IResponse<boolean>>(
      `${this.URI_API}RolePermission/delete`,
      permissionList
    );
  }
}
